if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}


if (!customElements.get('swiper-media-gallery')) {
  customElements.define('swiper-media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="swiper--"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        swiperThumbnails: document.querySelector('#swiper--product-thumbnail'),
        swiperMedia: document.querySelector('#swiper--media'),
      }
      this.mql = window.matchMedia('(min-width: 750px)'); 
      this.prevButton01 = this.querySelector('#button--prev-thumbnail');
      this.nextButton01 = this.querySelector('#button--next-thumbnail');
      if(!this.elements.swiperThumbnails.swiper){
        const swiperThumbnails = new Swiper(this.elements.swiperThumbnails, {
          spaceBetween: 0,
          navigation: {
          nextEl: "#button--next-thumbnail",
          prevEl: "#button--prev-thumbnail",
          }
        });
        const swiperMedia = new Swiper(this.elements.swiperMedia, {
          spaceBetween: 0,
          navigation: {
            nextEl: "#button--next-media",
            prevEl: "#button--prev-media",
          }
        });
      }
      
      if (!this.nextButton01 || !this.prevButton01) return;
      this.prevButton01.addEventListener('click', debounce(this.onSlideChanged.bind(this), 500));
      this.nextButton01.addEventListener('click', debounce(this.onSlideChanged.bind(this), 500));
      if (!this.elements.thumbnails) return;
    }

    onSlideChanged(event) {
      console.dir(this.elements);
      const slideIndex = this.elements.swiperThumbnails.swiper.realIndex;
      this.elements.swiperMedia.swiper.slideTo(slideIndex);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      const swiperThumbnails = new Swiper(this.elements.swiperThumbnails, {
        spaceBetween: 0,
        navigation: {
        nextEl: "#button--next-thumbnail",
        prevEl: "#button--prev-thumbnail",
        }
      });
      const swiperMedia = new Swiper(this.elements.swiperMedia, {
        spaceBetween: 0,
        navigation: {
          nextEl: "#button--next-media",
          prevEl: "#button--prev-media",
        }
      });
      swiperThumbnails.slideTo(activeMedia.dataset.index);
      swiperMedia.slideTo(activeMedia.dataset.index);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      // this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}



class VariantSelects2 extends HTMLElement {
  constructor() {
    super();
    this.swiperThumbnails = new Swiper("#swiper--product-thumbnail", {
      spaceBetween: 0,
      navigation: {
        nextEl: "#button--next-thumbnail",
        prevEl: "#button--prev-thumbnail",
      }
    });
    this.swiperMedia = new Swiper("#swiper--media", {
      spaceBetween: 0,
      navigation: {
        nextEl: "#button--next-media",
        prevEl: "#button--prev-media",
      }
    });
    this.addEventListener('load', this.loadVariant());
  }

  loadVariant() {
    this.updateOptions();
    this.updateMasterId();
    this.setMedia();
  }


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  setMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const targetMedia = document.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    this.swiperThumbnails.slideTo(targetMedia.offsetParent.dataset.index);
    this.swiperMedia.slideTo(targetMedia.offsetParent.dataset.index);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    // console.log(this.variantData);
    return this.variantData;
  }
};

customElements.define('variant-selects-select', VariantSelects2);



